import Http from "@/commons/Http";
import JWTBusiness from "@/business/JWTBusiness";
import FrontBusiness from "@/business/FrontBusiness";

export default {

  async getLoggedUser(){
    return Http.get('/api/autenticacao').catch((error) => {
      if (error.message === 'Network Error') {
        FrontBusiness.redirect(`/error`);
      }
      return null;
    });
  },

  async refreshToken(){
    return Http.get('/api/refresh-token').then(token => {
      JWTBusiness.setJwtToken(token);
    }).catch(() => {
      JWTBusiness.setJwtToken();
    });
  },

  async logout(){
    JWTBusiness.setJwtToken();
    await Http.post('logout');
  },

  async login(username, password){
    await this.logout();
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    return Http.post('/login', {username, password});
  },

}
